import importAll from '@core/utils/importAll'

import Vue from 'vue'
import Vuex from 'vuex'
const storeModules = importAll(require.context('@src', true, /^\.\/[\s\S]+\/store\/[\s\S]+\.js$/))

Vue.use(Vuex)
delete storeModules.index

const store = new Vuex.Store({
  modules: storeModules,
  strict: false
})
export default store



// WEBPACK FOOTER //
// ./src/area-core/store/index.js